import ahoy from "ahoy.js";
  
$(document).on('turbolinks:load', function () {

    $('.diseasestatebutton').click(function (e) {
        console.log("dndndndndndnndndndndndnndndn")
        document.getElementById('map-click').style.pointerEvents = 'auto';

        var valCap = $(this).val().charAt(0).toUpperCase() + $(this).val().slice(1)
        ahoy.track("asset_view",  {category: "Map Page", title: valCap+" Map Page"})

    })



})